export const excludeParlorPriceList: string[] = [
  "908",
];
